import React from 'react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
import ReactCodeInput from 'react-code-input'
import { inject, observer } from 'mobx-react'

import { APIURL } from '/constants'
import FormikField from '/components/forms/FormikField'
import LoadingButton from '/components/common/LoadingButton'
import services from '/components/services'

import { VisbilityContainer, CommonPose } from '../home/Animations'

export const EmailForm = ({ onComplete }) => {
  const handlePost = async (values, setErrors, setSubmitting) => {
    try {
      const res = await services.post_v2(APIURL.API_MAGIC_LINK_SEND, values)
      if (res.statusCode === 200 && res?.response?.id) {
        onComplete(res.response.id)
        return
      } else if (res.statusCode === 500) {
        setErrors({
          global:
            'Unable to submit the form at this time. Please try again later'
        })
      } else {
        setErrors({
          global: res.message
        })
      }
    } catch (e) {
      console.error(e)
    }
    setSubmitting(false)
  }
  return (
    <VisbilityContainer>
      <Panel>
        <Formik
          initialValues={{
            email: ''
          }}
          validationSchema={Yup.object({
            email: Yup.string().required('Required')
          })}
          onSubmit={async (values, { setSubmitting, setErrors }) => {
            await handlePost(values, setErrors, setSubmitting)
          }}
        >
          {({ isSubmitting, setFieldValue, errors }) => (
            <Form>
              {errors.global && (
                <Errors dangerouslySetInnerHTML={{ __html: errors.global }} />
              )}
              <CommonPose className="text-center">
                <P>Please enter your email address and we'll email you a login code.</P>
                <FormikField name="email">
                  <Field
                    className="form-control"
                    name="email"
                    placeholder="Email"
                    type="email"
                    autoFocus
                  />
                </FormikField>
              </CommonPose>
              <Action className="text-center">
                <LoadingButton
                  text="Send login code"
                  isLoading={isSubmitting}
                />
              </Action>
            </Form>
          )}
        </Formik>
      </Panel>
    </VisbilityContainer>
  )
}

export const PinForm = inject('store')(
  observer(({ id, store, onComplete }) => {
    const handlePin = async (values, setErrors) => {
      try {
        const res = await services.post_v2(APIURL.API_MAGIC_VERIFY_PIN, {
          id: id,
          pin: values.pin
        })
        if (res.statusCode === 200) {
          store.setupSession(null, res)
          if (onComplete) {
            onComplete(res.response)
          }
        } else if (res.statusCode === 500) {
          setErrors({
            global:
              'Unable to submit the form at this time. Please try again later'
          })
        } else {
          setErrors({
            global: res.message
          })
        }
      } catch (e) {
        console.error(e)
      }
      setSubmitting(false)
    }
    return (
      <VisbilityContainer>
        <Panel>
          <Formik
            initialValues={{
              pin: ''
            }}
            validationSchema={Yup.object({
              pin: Yup.string().required('Required')
            })}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              await handlePin(values, setErrors, setSubmitting)
            }}
          >
            {({ isSubmitting, setFieldValue, errors }) => (
              <Form>
                {errors.global && (
                  <Errors dangerouslySetInnerHTML={{ __html: errors.global }} />
                )}
                <CommonPose class="text-center">
                  <P>Please enter the login code you received in your inbox</P>
                  <FormikField name="pin" label="">
                    <ReactCodeInput
                        type='number'
                        style={{ textAlign: 'center' }}
                        autoFocus
                        fields={6}
                        onChange={ (e) => {
                          setFieldValue('pin', e)
                        }} />
                  </FormikField>
                </CommonPose>
                <Action className="text-center">
                  <LoadingButton
                    text="Sign In"
                    isLoading={isSubmitting}
                  />
                </Action>
              </Form>
            )}
          </Formik>
        </Panel>
      </VisbilityContainer>
    )
  })
)

export const MagicForm = ({ onComplete }) => {
  const [ id, setId ] = React.useState('')
  if (id) {
    return (<PinForm id={id} onComplete={onComplete} />)
  } else {
    return (<EmailForm onComplete={(magicId) => setId(magicId)} />)
  }
}

const Errors = styled.div`
  text-align: center;
  font-weight: bold;
  padding: 10px 0;
  color: ${(props) => props.theme.colors.danger};
  margin: 0 auto;
  font-weight: 400;
`

const Action = styled(CommonPose)`
  padding: 20px 0;
`

const Panel = styled.div`
  max-width: 350px;
`

const P = styled.p`
  padding: 0 0 20px 0;
`
